// extracted by css-extract-rspack-plugin
export default {"mainCard":"ClaimSearchHeader_mainCard__4YjTE","headerTitle":"ClaimSearchHeader_headerTitle__b2Ckp","error":"ClaimSearchHeader_error__c56EO"};